import React from 'react';

// CSS-based pixel art sprites for FF1 characters
// Each sprite is 16x16 pixels scaled up for visibility

interface SpriteProps {
  className?: string;
  size?: number;
}

// Fighter sprite - red armor with sword
export const FighterSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* Hair */}
    <rect x="5" y="1" width="6" height="2" fill="#8B4513" />
    <rect x="4" y="2" width="1" height="1" fill="#8B4513" />
    <rect x="11" y="2" width="1" height="1" fill="#8B4513" />
    {/* Face */}
    <rect x="5" y="3" width="6" height="3" fill="#FFDBAC" />
    <rect x="6" y="3" width="1" height="1" fill="#000" />
    <rect x="9" y="3" width="1" height="1" fill="#000" />
    {/* Helmet */}
    <rect x="4" y="1" width="1" height="2" fill="#C0C0C0" />
    <rect x="11" y="1" width="1" height="2" fill="#C0C0C0" />
    {/* Red armor body */}
    <rect x="4" y="6" width="8" height="5" fill="#DC143C" />
    <rect x="3" y="7" width="1" height="3" fill="#DC143C" />
    <rect x="12" y="7" width="1" height="3" fill="#DC143C" />
    {/* Belt */}
    <rect x="5" y="9" width="6" height="1" fill="#FFD700" />
    {/* Legs */}
    <rect x="5" y="11" width="2" height="4" fill="#8B0000" />
    <rect x="9" y="11" width="2" height="4" fill="#8B0000" />
    {/* Feet */}
    <rect x="4" y="14" width="3" height="2" fill="#4A4A4A" />
    <rect x="9" y="14" width="3" height="2" fill="#4A4A4A" />
    {/* Sword */}
    <rect x="13" y="5" width="2" height="1" fill="#C0C0C0" />
    <rect x="14" y="6" width="1" height="5" fill="#C0C0C0" />
    <rect x="14" y="11" width="1" height="1" fill="#FFD700" />
  </svg>
);

// Thief sprite - purple with dagger
export const ThiefSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* Hood */}
    <rect x="4" y="0" width="8" height="3" fill="#4B0082" />
    <rect x="3" y="1" width="1" height="3" fill="#4B0082" />
    <rect x="12" y="1" width="1" height="3" fill="#4B0082" />
    {/* Face */}
    <rect x="5" y="3" width="6" height="3" fill="#FFDBAC" />
    <rect x="6" y="3" width="1" height="1" fill="#000" />
    <rect x="9" y="3" width="1" height="1" fill="#000" />
    {/* Purple cloak body */}
    <rect x="4" y="6" width="8" height="5" fill="#800080" />
    <rect x="3" y="7" width="1" height="4" fill="#800080" />
    <rect x="12" y="7" width="1" height="4" fill="#800080" />
    {/* Belt with pouch */}
    <rect x="5" y="9" width="6" height="1" fill="#8B4513" />
    <rect x="10" y="8" width="2" height="2" fill="#8B4513" />
    {/* Legs */}
    <rect x="5" y="11" width="2" height="4" fill="#4B0082" />
    <rect x="9" y="11" width="2" height="4" fill="#4B0082" />
    {/* Boots */}
    <rect x="4" y="14" width="3" height="2" fill="#2F1B0C" />
    <rect x="9" y="14" width="3" height="2" fill="#2F1B0C" />
    {/* Dagger */}
    <rect x="1" y="8" width="1" height="1" fill="#FFD700" />
    <rect x="2" y="7" width="1" height="3" fill="#C0C0C0" />
  </svg>
);

// Monk sprite - orange gi, muscular
export const MonkSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* Bald head */}
    <rect x="5" y="1" width="6" height="2" fill="#FFDBAC" />
    <rect x="4" y="2" width="1" height="2" fill="#FFDBAC" />
    <rect x="11" y="2" width="1" height="2" fill="#FFDBAC" />
    {/* Face */}
    <rect x="5" y="3" width="6" height="3" fill="#FFDBAC" />
    <rect x="6" y="3" width="1" height="1" fill="#000" />
    <rect x="9" y="3" width="1" height="1" fill="#000" />
    {/* Orange gi body */}
    <rect x="4" y="6" width="8" height="5" fill="#FF8C00" />
    <rect x="3" y="7" width="1" height="3" fill="#FFDBAC" />
    <rect x="12" y="7" width="1" height="3" fill="#FFDBAC" />
    {/* Black belt */}
    <rect x="5" y="9" width="6" height="1" fill="#000" />
    {/* Legs */}
    <rect x="5" y="11" width="2" height="4" fill="#FF6600" />
    <rect x="9" y="11" width="2" height="4" fill="#FF6600" />
    {/* Bare feet */}
    <rect x="4" y="14" width="3" height="2" fill="#FFDBAC" />
    <rect x="9" y="14" width="3" height="2" fill="#FFDBAC" />
    {/* Fists */}
    <rect x="2" y="9" width="2" height="2" fill="#FFDBAC" />
    <rect x="12" y="9" width="2" height="2" fill="#FFDBAC" />
  </svg>
);

// Red Mage sprite - red hat with feather
export const RedMageSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* Red hat */}
    <rect x="4" y="0" width="8" height="3" fill="#DC143C" />
    <rect x="3" y="2" width="2" height="2" fill="#DC143C" />
    <rect x="11" y="2" width="2" height="2" fill="#DC143C" />
    {/* Feather */}
    <rect x="11" y="0" width="1" height="1" fill="#FFF" />
    <rect x="12" y="1" width="1" height="2" fill="#FFF" />
    {/* Face with mask */}
    <rect x="5" y="3" width="6" height="3" fill="#FFDBAC" />
    <rect x="5" y="4" width="6" height="1" fill="#DC143C" />
    <rect x="6" y="3" width="1" height="1" fill="#000" />
    <rect x="9" y="3" width="1" height="1" fill="#000" />
    {/* Red cape/robe */}
    <rect x="4" y="6" width="8" height="5" fill="#DC143C" />
    <rect x="3" y="7" width="1" height="5" fill="#8B0000" />
    <rect x="12" y="7" width="1" height="5" fill="#8B0000" />
    {/* White shirt underneath */}
    <rect x="6" y="6" width="4" height="3" fill="#FFF" />
    {/* Belt */}
    <rect x="5" y="9" width="6" height="1" fill="#FFD700" />
    {/* Legs */}
    <rect x="5" y="11" width="2" height="4" fill="#8B0000" />
    <rect x="9" y="11" width="2" height="4" fill="#8B0000" />
    {/* Boots */}
    <rect x="4" y="14" width="3" height="2" fill="#2F1B0C" />
    <rect x="9" y="14" width="3" height="2" fill="#2F1B0C" />
    {/* Rapier */}
    <rect x="14" y="6" width="1" height="6" fill="#C0C0C0" />
    <rect x="13" y="10" width="3" height="1" fill="#FFD700" />
  </svg>
);

// White Mage sprite - white robes, hood
export const WhiteMageSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* White hood */}
    <rect x="4" y="0" width="8" height="4" fill="#F0F0F0" />
    <rect x="3" y="1" width="1" height="4" fill="#F0F0F0" />
    <rect x="12" y="1" width="1" height="4" fill="#F0F0F0" />
    {/* Face */}
    <rect x="5" y="3" width="6" height="3" fill="#FFDBAC" />
    <rect x="6" y="3" width="1" height="1" fill="#000" />
    <rect x="9" y="3" width="1" height="1" fill="#000" />
    {/* Hood edge red trim */}
    <rect x="4" y="4" width="1" height="2" fill="#DC143C" />
    <rect x="11" y="4" width="1" height="2" fill="#DC143C" />
    {/* White robe body */}
    <rect x="4" y="6" width="8" height="6" fill="#F0F0F0" />
    <rect x="3" y="7" width="1" height="5" fill="#E0E0E0" />
    <rect x="12" y="7" width="1" height="5" fill="#E0E0E0" />
    {/* Red cross */}
    <rect x="7" y="7" width="2" height="4" fill="#DC143C" />
    <rect x="6" y="8" width="4" height="2" fill="#DC143C" />
    {/* Robe bottom */}
    <rect x="4" y="12" width="8" height="4" fill="#F0F0F0" />
    {/* Feet peek */}
    <rect x="5" y="15" width="2" height="1" fill="#FFDBAC" />
    <rect x="9" y="15" width="2" height="1" fill="#FFDBAC" />
    {/* Staff */}
    <rect x="1" y="4" width="1" height="10" fill="#8B4513" />
    <rect x="0" y="3" width="3" height="2" fill="#87CEEB" />
  </svg>
);

// Black Mage sprite - blue robe, glowing eyes
export const BlackMageSprite: React.FC<SpriteProps> = ({ className = '', size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className}
    style={{ imageRendering: 'pixelated' }}
  >
    {/* Pointy hat */}
    <rect x="7" y="0" width="2" height="1" fill="#191970" />
    <rect x="6" y="1" width="4" height="1" fill="#191970" />
    <rect x="5" y="2" width="6" height="2" fill="#191970" />
    <rect x="4" y="3" width="8" height="1" fill="#191970" />
    {/* Hat brim */}
    <rect x="3" y="4" width="10" height="1" fill="#FFD700" />
    {/* Dark face (shadow) */}
    <rect x="5" y="5" width="6" height="2" fill="#000" />
    {/* Glowing yellow eyes */}
    <rect x="6" y="5" width="1" height="1" fill="#FFD700" />
    <rect x="9" y="5" width="1" height="1" fill="#FFD700" />
    {/* Blue robe body */}
    <rect x="4" y="7" width="8" height="5" fill="#191970" />
    <rect x="3" y="8" width="1" height="4" fill="#000080" />
    <rect x="12" y="8" width="1" height="4" fill="#000080" />
    {/* Hands (hidden in sleeves - just dark) */}
    <rect x="2" y="10" width="2" height="2" fill="#191970" />
    <rect x="12" y="10" width="2" height="2" fill="#191970" />
    {/* Robe bottom */}
    <rect x="4" y="12" width="8" height="4" fill="#191970" />
    <rect x="5" y="14" width="2" height="2" fill="#000080" />
    <rect x="9" y="14" width="2" height="2" fill="#000080" />
    {/* Staff with orb */}
    <rect x="14" y="4" width="1" height="10" fill="#8B4513" />
    <rect x="13" y="2" width="3" height="3" fill="#FF4500" />
    <rect x="14" y="3" width="1" height="1" fill="#FFD700" />
  </svg>
);

// Crystal sprite - can be any color
interface CrystalSpriteProps extends SpriteProps {
  color: 'fire' | 'water' | 'earth' | 'wind';
  style?: React.CSSProperties;
}

export const CrystalSprite: React.FC<CrystalSpriteProps> = ({ className = '', size = 48, color, style }) => {
  const colors = {
    fire: { main: '#FF4500', light: '#FF6B35', dark: '#CC3700', glow: '#FFD700' },
    water: { main: '#1E90FF', light: '#5CACEE', dark: '#1569C7', glow: '#87CEEB' },
    earth: { main: '#8B4513', light: '#A0522D', dark: '#5C3317', glow: '#DEB887' },
    wind: { main: '#32CD32', light: '#7CFC00', dark: '#228B22', glow: '#ADFF2F' },
  };

  const c = colors[color];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 20"
      className={className}
      style={{ imageRendering: 'pixelated', ...style }}
    >
      {/* Glow effect */}
      <rect x="6" y="1" width="4" height="1" fill={c.glow} opacity="0.5" />
      <rect x="5" y="2" width="6" height="1" fill={c.glow} opacity="0.3" />

      {/* Crystal top point */}
      <rect x="7" y="2" width="2" height="2" fill={c.light} />

      {/* Crystal upper body */}
      <rect x="6" y="4" width="4" height="2" fill={c.light} />
      <rect x="5" y="5" width="1" height="2" fill={c.main} />
      <rect x="10" y="5" width="1" height="2" fill={c.dark} />

      {/* Crystal middle body */}
      <rect x="4" y="6" width="8" height="4" fill={c.main} />
      <rect x="3" y="7" width="1" height="3" fill={c.dark} />
      <rect x="12" y="7" width="1" height="3" fill={c.dark} />

      {/* Highlight */}
      <rect x="5" y="7" width="2" height="2" fill={c.light} />

      {/* Crystal lower body */}
      <rect x="4" y="10" width="8" height="3" fill={c.main} />
      <rect x="5" y="13" width="6" height="2" fill={c.main} />
      <rect x="6" y="15" width="4" height="2" fill={c.dark} />
      <rect x="7" y="17" width="2" height="2" fill={c.dark} />

      {/* Bottom point */}
      <rect x="7" y="18" width="2" height="1" fill={c.dark} />
    </svg>
  );
};

// All characters in a row component
export const PartySprites: React.FC<{ size?: number; className?: string }> = ({
  size = 48,
  className = ''
}) => (
  <div className={`flex items-end justify-center gap-2 ${className}`}>
    <FighterSprite size={size} />
    <ThiefSprite size={size} />
    <MonkSprite size={size} />
    <RedMageSprite size={size} />
    <WhiteMageSprite size={size} />
    <BlackMageSprite size={size} />
  </div>
);

// Four crystals in a row
export const FourCrystals: React.FC<{ size?: number; className?: string }> = ({
  size = 40,
  className = ''
}) => (
  <div className={`flex items-center justify-center gap-4 ${className}`}>
    <CrystalSprite color="fire" size={size} className="animate-pulse" />
    <CrystalSprite color="water" size={size} className="animate-pulse" style={{ animationDelay: '0.25s' }} />
    <CrystalSprite color="earth" size={size} className="animate-pulse" style={{ animationDelay: '0.5s' }} />
    <CrystalSprite color="wind" size={size} className="animate-pulse" style={{ animationDelay: '0.75s' }} />
  </div>
);

// Render sprite by class ID
interface ClassSpriteProps extends SpriteProps {
  classId: number;
}

export const ClassSprite: React.FC<ClassSpriteProps> = ({ classId, size = 64, className = '' }) => {
  switch (classId) {
    case 0: return <FighterSprite size={size} className={className} />;
    case 1: return <ThiefSprite size={size} className={className} />;
    case 2: return <MonkSprite size={size} className={className} />;
    case 3: return <RedMageSprite size={size} className={className} />;
    case 4: return <WhiteMageSprite size={size} className={className} />;
    case 5: return <BlackMageSprite size={size} className={className} />;
    default: return <FighterSprite size={size} className={className} />;
  }
};

export default {
  FighterSprite,
  ThiefSprite,
  MonkSprite,
  RedMageSprite,
  WhiteMageSprite,
  BlackMageSprite,
  CrystalSprite,
  ClassSprite,
  PartySprites,
  FourCrystals,
};
